import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Input from '@components/common/Input';
import useStyles from './styles';

interface PayerFieldsProps {
  errorFields: boolean;
}

const PayerFields: FC<PayerFieldsProps> = ({ errorFields }) => {
  const { control, formState } = useFormContext();
  const { t } = useTranslation();
  const css = useStyles();

  return (
    <Grid className={css.formRow}>
      <Controller
        control={control}
        defaultValue=""
        name="cardHolderName"
        rules={{ required: true }}
        render={({ field: { ref, ...field }, fieldState }) => (
          <Input
            {...field}
            inputRef={ref}
            label={t('checkoutScreen.payment.methods.card.name')}
            fullWidth
            inputProps={{
              'data-testid': 'card-holder-name',
            }}
            autoComplete="off"
            disabled={formState.isSubmitting}
            error={fieldState.invalid || errorFields}
          />
        )}
      />
    </Grid>
  );
};

export default PayerFields;
